import { FlexibleColumn } from '@ip-only/front-end-library';

const iconColumn: FlexibleColumn = {
  id: 'icon',
  header: '',
  alignment: 'left',
  narrow: true,
};

const nameColumn: FlexibleColumn = {
  id: 'name',
  header: 'name',
  alignment: 'left',
};

const modifiedColumn: FlexibleColumn = {
  id: 'modified',
  header: 'modified',
  alignment: 'left',
};

const sizeColumn: FlexibleColumn = {
  id: 'size',
  header: 'size',
  alignment: 'left',
};

const buttonColumn: FlexibleColumn = {
  id: 'button',
  header: '',
  alignment: 'right',
  narrow: true,
};

export const folderContentColumns: FlexibleColumn[] = [
  iconColumn,
  nameColumn,
  modifiedColumn,
  sizeColumn,
  buttonColumn,
];
